import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { SidebarModule, DropdownModule } from '@coreui/angular';
import { IconSetService } from '@coreui/icons-angular';
import {
  importProvidersFrom, provideAppInitializer, provideZoneChangeDetection
} from '@angular/core';
import { AppComponent } from './app/app.component';
import {  AuthInterceptor } from './app/auth.interceptor';
import { ErrorInterceptor } from './app/error-interceptor';
import { loaderInterceptor } from './app/loader.interceptor';
import { orgHeadersInterceptor } from './app/org-headers.interceptor';
import { saveToastInterceptor } from './app/save-toast.interceptor';
import { routes } from './app/app.routes';
import { hydrateSession } from './app/session-boot';

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),provideHttpClient(withXhr(), withInterceptorsFromDi(),
    // orgHeaders runs after the DI interceptors, so the auth
    // interceptor's 401-retry keeps the org/device headers too.
    withInterceptors([loaderInterceptor, saveToastInterceptor, orgHeadersInterceptor])),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    // Was written but never registered, so every API error — including the
    // 400 the CMS returns for a non-admin sign-in — was swallowed silently.
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    // Before the first route is decided: who is signed in, and which
    // organization they are staff of. A guard that has to guess that
    // sends org staff to the platform dashboard.
    provideAppInitializer(hydrateSession),
    provideRouter(routes, withHashLocation() ),
    provideAnimations(),
    importProvidersFrom(SidebarModule, DropdownModule),
    IconSetService
  ]
});
